import classes from './ChatWidget.module.scss'
import { ButtonDefinition } from './types'
import { getGroupIcon, groupButtons } from './ActionCards'
import { IconSpark } from './icons'

interface Props {
  open: boolean
  buttons: ButtonDefinition[]
  onButton: (b: ButtonDefinition) => void
  disabled?: boolean
}

/**
 * Sağ sidebar: "Hızlı Bağlantılar". Backend buton kataloğu grup kartları olarak listelenir;
 * tıklama ActionCards ile aynı intent akışını tetikler. En altta statik yardım kartı.
 */
export default function QuickLinksSidebar({ open, buttons, onButton, disabled }: Props) {
  const groups = groupButtons(buttons)
  const grouped = groups.filter(g => g.label)
  const solo = groups.filter(g => !g.label).map(g => g.items[0])

  return (
    <div className={`${classes.sidebar} ${classes.sidebarRight}`} aria-hidden={!open}>
      <div className={classes.sidebarInner}>
        <div className={classes.sidebarHead}>
          <h2 className={classes.sidebarTitle}>Hızlı Bağlantılar</h2>
        </div>
        <div className={classes.sidebarBody}>
          {grouped.map(g => {
            const Icon = getGroupIcon(g.label)
            return (
              <div key={g.key} className={classes.linkCard}>
                <div className={classes.linkCardHead}>
                  <Icon />
                  {g.label}
                </div>
                {g.items.map(b => (
                  <button
                    key={b.Intent}
                    type='button'
                    className={classes.linkItem}
                    onClick={() => onButton(b)}
                    disabled={disabled}
                    title={b.Label}
                  >
                    {b.Label}
                  </button>
                ))}
              </div>
            )
          })}

          {solo.length > 0 && (
            <div className={classes.linkCard}>
              <div className={classes.linkCardHead}>
                <IconSpark />
                Hızlı İşlemler
              </div>
              {solo.map(b => (
                <button
                  key={b.Intent}
                  type='button'
                  className={classes.linkItem}
                  onClick={() => onButton(b)}
                  disabled={disabled}
                  title={b.Label}
                >
                  {b.Label}
                </button>
              ))}
            </div>
          )}

          <p className={classes.linkNote}>
            B-Gini yanıtları bazen hatalı olabilir. Lütfen önemli bilgileri doğrulayın.
          </p>
        </div>
      </div>
    </div>
  )
}
